import React from 'react';
import RuleForm from './RuleForm';

const CreateRule: React.FC = () => {
  return <RuleForm mode="create" />;
};

export default CreateRule;
